// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-60d138e2] .sidebar .nuxt-link-active{font-weight:600;--text-opacity:1;color:#4372c8;color:rgba(67,114,200,var(--text-opacity));position:relative;border-right-width:4px}[data-v-60d138e2] table{width:100%}[data-v-60d138e2] table tbody tr td p{font-size:16px!important}[data-v-60d138e2] img{object-fit:cover;object-position:left top}@media (max-width:768px){[data-v-60d138e2] table tbody tr td{padding-left:.75rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
